import { useMutation, useQueryClient } from '@tanstack/react-query';

import {
  UserProfileSoporteKeysEnum,
  handleAxiosError,
  urlBackend,
} from '@/shared';
import { erpApi } from '@/shared/axios/erp-api';
import {
  AlertSeverityEnum,
  UseMutationsParams,
  UserSimple,
} from '@/shared/interfaces';
import { useUiStore } from '@/store/ui';

const { post } = erpApi();

////* tanStack query
export const useUnblockUser = ({
  navigate,
  returnUrl,
  enableRedirect = true,
}: UseMutationsParams) => {
  const queryClient = useQueryClient();
  const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;
  const setAlert = useUiStore.getState().setAlert;

  return useMutation({
    mutationFn: unblockUserUpd,

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [UserProfileSoporteKeysEnum.USERS_PROFILE_ALL],
      });

      setAlert(
        true,
        'El usuario ha sido desbloqueado correctamente',
        AlertSeverityEnum.success
      );

      enableRedirect && navigate && returnUrl && navigate(returnUrl);
    },
    onError: error => {
      handleAxiosError(error);
    },
    onSettled: () => {
      setIsGlobalLoading(false);
    },
  });
};

////* axios
export type UnblockUserParams = {
  username: string;
};

export const unblockUserUpd = async ({ username }: UnblockUserParams) => {
  const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;
  setIsGlobalLoading(true);

  return post<UserSimple>(
    `${urlBackend}api/v1/desbloquear-usuario/`,
    {
      username,
    },
    true
  );
};
